var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.3771,
    y: 37.6973,
    width: 1.35019,
    height: 2.70039,
    fill: "#585858"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3771,
    y: 33.936,
    width: 1.35019,
    height: 2.89327,
    fill: "#585858"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3771,
    y: 30.0784,
    width: 1.35019,
    height: 2.60394,
    fill: "#585858"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.174,
    y: 37.6973,
    width: 1.35019,
    height: 2.70039,
    fill: "#585858"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.174,
    y: 33.936,
    width: 1.35019,
    height: 2.89327,
    fill: "#585858"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.174,
    y: 30.0784,
    width: 1.35019,
    height: 2.60394,
    fill: "#585858"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8744,
    y: 37.6973,
    width: 1.35019,
    height: 2.70039,
    fill: "#585858"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8744,
    y: 33.936,
    width: 1.35019,
    height: 2.89327,
    fill: "#585858"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8744,
    y: 30.0784,
    width: 1.35019,
    height: 2.60394,
    fill: "#585858"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7031 44.2398C53.5071 43.7981 54.8695 41.8802 54.8695 39.586C54.8695 37.2918 53.5071 35.3738 51.7031 34.9321V9.50489H50.1199V6.33847H46.9534V3.17205H45.3504L45.3702 0.0102483L43.787 0L43.7672 3.17203H42.2038V6.33845H39.0374V9.50487H37.4542V16.3746C35.7381 16.8407 34.1309 17.597 32.7045 18.607V11.0882H35.871V6.33854H31.9129V3.17212H30.3099L30.3297 0.0103134L28.7465 6.514e-05L28.7267 3.17209H27.1633V6.33851H23.2053V11.0881H26.3717V26.3023L23.2053 25.5107V19.0044H24.7885V17.4212H20.0389V12.6715H18.4557V17.4212H16.8724V15.838H15.2892V17.4212H13.706V14.2547H12.1228V17.4212H7.37319V19.0044H8.9564V43.5649C8.00087 44.2876 7.37319 45.4231 7.37319 46.7108C7.37319 46.9783 7.40888 47.242 7.46189 47.5024H0V48H59.3025V47.5024H51.7031L51.7031 44.2398ZM27.9549 43.0926C26.8237 42.6025 25.4628 42.6643 24.3941 43.2867C23.3534 41.9621 21.7529 41.1691 20.0389 41.1691C18.8687 41.1691 17.7782 41.5374 16.8724 42.1675V25.5591L27.9549 28.3298V43.0926ZM28.5518 26.8471L28.6398 26.628C30.3877 21.373 35.1426 17.7635 40.6206 17.4445V44.8865C39.7396 44.4652 38.7476 44.262 37.7225 44.3617C36.8209 42.4275 34.8815 41.1698 32.7046 41.1698C31.5511 41.1698 30.4531 41.5363 29.5382 42.1752V27.094L28.5518 26.8471ZM43.7868 39.5861V42.5578C42.8676 42.121 42.2036 40.9605 42.2036 39.5861C42.2036 37.8399 43.2691 36.4196 44.5784 36.4196C45.8878 36.4196 46.9532 37.8399 46.9532 39.5861C46.9532 40.9604 46.2892 42.1206 45.37 42.5578V39.5861H43.7868ZM42.2036 46.0257V43.3763C42.6644 43.7933 43.2008 44.0958 43.7868 44.2393V47.5021H43.2334C42.969 46.9487 42.6217 46.4539 42.2036 46.0257ZM45.37 44.24C46.3372 44.0032 47.1734 43.3392 47.7448 42.4239C48.3163 43.3399 49.1524 44.0032 50.1196 44.24V47.5022H45.37V44.24ZM53.2861 39.5862C53.2861 40.9605 52.622 42.1207 51.7029 42.5579V39.5862H50.1196V42.5579C49.2005 42.1211 48.5364 40.9606 48.5364 39.5862C48.5364 37.84 49.6019 36.4197 50.9112 36.4197C52.2206 36.4197 53.2861 37.84 53.2861 39.5862ZM43.7868 4.75554H45.37V6.33875H43.7868V4.75554ZM40.6204 7.92196H48.5364V9.50517H40.6204V7.92196ZM39.0372 11.0884H50.1196V34.9324C49.1524 35.1692 48.3162 35.8332 47.7448 36.7485C47.0221 35.5911 45.8736 34.8366 44.5784 34.8366C43.6871 34.8366 42.8662 35.1967 42.2036 35.7954V15.8379H41.412C40.607 15.8379 39.8136 15.9019 39.0372 16.0256V11.0884ZM28.7463 4.75554H30.3295V6.33875H28.7463V4.75554ZM24.7883 7.92196H34.2876V9.50517H24.7883V7.92196ZM31.1211 11.0884V19.906C29.8348 21.1106 28.7565 22.5444 27.9547 24.1615V11.0887L31.1211 11.0884ZM10.5394 19.0044H21.6219V25.115L15.289 23.5318V43.871C15.1915 44.0357 15.0925 44.1997 15.0113 44.3753C14.8452 44.3524 14.6755 44.3396 14.4999 44.3382C13.7574 43.349 12.5841 42.7522 11.331 42.7522C11.0603 42.7522 10.7953 42.7798 10.5394 42.8321L10.5394 19.0044ZM8.95619 46.7106C8.95619 45.4012 10.0216 44.3358 11.331 44.3358C12.1866 44.3358 12.98 44.7987 13.4012 45.5444L13.6465 45.979L14.4974 45.919C14.7303 45.919 14.9756 45.9642 15.2488 46.0561L16.0174 46.3141L16.2573 45.5391C16.7726 43.8728 18.2925 42.7525 20.0387 42.7525C21.4788 42.7525 22.8069 43.5371 23.5045 44.8005L23.9992 45.6967L24.7417 44.992C25.6347 44.1467 27.107 44.1467 28 44.992L28.7425 45.6967L29.2373 44.8005C29.9363 43.5371 31.2643 42.7525 32.7044 42.7525C34.423 42.7525 35.9348 43.8513 36.467 45.4868L36.6893 46.1699L37.3915 46.0147C38.9563 45.6674 40.4915 46.3123 41.3937 47.5022H9.10976C9.01929 47.2474 8.95619 46.9838 8.95619 46.7106Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3662 20.5876H16.0583V22.1709H15.3662V20.5876Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2359 20.5876H12.928V22.1709H12.2359V20.5876Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.982 20.5876H14.6741V22.1709H13.982V20.5876Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.236 33.2532H12.9281V34.8364H12.236V33.2532Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.236 30.0869H12.9281V31.6701H12.236V30.0869Z",
    fill: "#585858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.236 26.9204H12.9281V28.5036H12.236V26.9204Z",
    fill: "#585858"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.236 36.4197H12.9281V38.0029H12.236V36.4197Z",
    fill: "#585858"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.236 23.7539H12.9281V25.3371H12.236V23.7539Z",
    fill: "#585858"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.236 39.5859H12.9281V41.1691H12.236V39.5859Z",
    fill: "#585858"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2878 38.0027H35.871V39.5859H34.2878V38.0027Z",
    fill: "#585858"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1214 38.0027H32.7046V39.5859H31.1214V38.0027Z",
    fill: "#585858"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4542 38.0027H39.0374V39.5859H37.4542V38.0027Z",
    fill: "#585858"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2878 34.8364H35.871V36.4196H34.2878V34.8364Z",
    fill: "#585858"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1214 34.8364H32.7046V36.4196H31.1214V34.8364Z",
    fill: "#585858"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4542 34.8364H39.0374V36.4196H37.4542V34.8364Z",
    fill: "#585858"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4542 31.6699H39.0374V33.2531H37.4542V31.6699Z",
    fill: "#585858"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1214 31.6699H32.7046V33.2531H31.1214V31.6699Z",
    fill: "#585858"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2878 31.6699H35.871V33.2531H34.2878V31.6699Z",
    fill: "#585858"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1214 28.5034H32.7046V30.0866H31.1214V28.5034Z",
    fill: "#585858"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4542 28.5034H39.0374V30.0866H37.4542V28.5034Z",
    fill: "#585858"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2878 28.5034H35.871V30.0866H34.2878V28.5034Z",
    fill: "#585858"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4542 25.3372H39.0374V26.9204H37.4542V25.3372Z",
    fill: "#585858"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2878 25.3372H35.871V26.9204H34.2878V25.3372Z",
    fill: "#585858"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1214 25.3372H32.7046V26.9204H31.1214V25.3372Z",
    fill: "#585858"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2878 22.1707H35.871V23.7539H34.2878V22.1707Z",
    fill: "#585858"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7087 20.5649H20.4008V22.136H19.7087V20.5649Z",
    fill: "#585858"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9403 20.5649H17.6324V22.136H16.9403V20.5649Z",
    fill: "#585858"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3245 20.5649H19.0166V22.136H18.3245V20.5649Z",
    fill: "#585858"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9548 33.1333H14.6469V34.7043H13.9548V33.1333Z",
    fill: "#585858"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9548 29.9912H14.6469V31.5622H13.9548V29.9912Z",
    fill: "#585858"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9548 26.8491H14.6469V28.4202H13.9548V26.8491Z",
    fill: "#585858"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9548 36.2754H14.6469V37.8464H13.9548V36.2754Z",
    fill: "#585858"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9548 23.707H14.6469V25.2781H13.9548V23.707Z",
    fill: "#585858"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9548 39.4172H14.6469V40.9883H13.9548V39.4172Z",
    fill: "#585858"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4542 22.1707H39.0374V23.7539H37.4542V22.1707Z",
    fill: "#585858"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.787 15.8379H45.3702V17.4211H43.787V15.8379Z",
    fill: "#585858"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9535 15.8379H48.5367V17.4211H46.9535V15.8379Z",
    fill: "#585858"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9535 19.0042H48.5367V20.5874H46.9535V19.0042Z",
    fill: "#585858"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.787 19.0042H45.3702V20.5874H43.787V19.0042Z",
    fill: "#585858"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.787 22.1707H45.3702V23.7539H43.787V22.1707Z",
    fill: "#585858"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9535 22.1707H48.5367V23.7539H46.9535V22.1707Z",
    fill: "#585858"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9535 25.3372H48.5367V26.9204H46.9535V25.3372Z",
    fill: "#585858"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.787 25.3372H45.3702V26.9204H43.787V25.3372Z",
    fill: "#585858"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M43.787 28.5034H45.3702V30.0866H43.787V28.5034Z",
    fill: "#585858"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9535 28.5034H48.5367V30.0866H46.9535V28.5034Z",
    fill: "#585858"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9535 31.6699H48.5367V33.2531H46.9535V31.6699Z",
    fill: "#585858"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43.787 31.6699H45.3702V33.2531H43.787V31.6699Z",
    fill: "#585858"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9535 12.6714H48.5367V14.2546H46.9535V12.6714Z",
    fill: "#585858"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M43.787 12.6714H45.3702V14.2546H43.787V12.6714Z",
    fill: "#585858"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6206 12.6714H42.2038V14.2546H40.6206V12.6714Z",
    fill: "#585858"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3089 15.8604H46.4527V17.4436H45.3089V15.8604Z",
    fill: "#DFDFDF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4106 15.8604H49.5544V17.4436H48.4106V15.8604Z",
    fill: "#DFDFDF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4106 19.0269H49.5544V20.6101H48.4106V19.0269Z",
    fill: "#DFDFDF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3089 19.0269H46.4527V20.6101H45.3089V19.0269Z",
    fill: "#DFDFDF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3089 22.1931H46.4527V23.7763H45.3089V22.1931Z",
    fill: "#DFDFDF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4106 22.1931H49.5544V23.7763H48.4106V22.1931Z",
    fill: "#DFDFDF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4106 25.3596H49.5544V26.9428H48.4106V25.3596Z",
    fill: "#DFDFDF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3089 25.3596H46.4527V26.9428H45.3089V25.3596Z",
    fill: "#DFDFDF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3089 28.5261H46.4527V30.1093H45.3089V28.5261Z",
    fill: "#DFDFDF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4106 28.5261H49.5544V30.1093H48.4106V28.5261Z",
    fill: "#DFDFDF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4106 31.6924H49.5544V33.2756H48.4106V31.6924Z",
    fill: "#DFDFDF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3089 31.6924H46.4527V33.2756H45.3089V31.6924Z",
    fill: "#DFDFDF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4106 12.6941H49.5544V14.2773H48.4106V12.6941Z",
    fill: "#DFDFDF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3089 12.6941H46.4527V14.2773H45.3089V12.6941Z",
    fill: "#DFDFDF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1166 12.6035H43.2604V14.1867H42.1166V12.6035Z",
    fill: "#DFDFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.eaf04490fe1fb36de3e749748833f4e7.svg";
export { ForwardRef as ReactComponent };